//@ts-check
import validator from './validator';
import validateFolderName from './folderName';
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = validator.shouldBeSpecified(value, 'Folder path');
  if (error) return error;
  if (validator.shouldNotContainChars(value, ['\\'])) return 'Use "/" instead of "\\" to type paths';
  if (validator.shouldContainChars(value, ['/'])) return validateFolderName(value);
  var returnValue = undefined;
  var seg = value.split('/');
  if (!seg[seg.length - 1]) seg.pop();
  seg.map(function (folderName) {
    var error = validateFolderName(folderName);
    if (error) returnValue = error;
  });
  return returnValue;
});